import { configure, getPreferences, onPreferencesChanged } from 'cookie-though';
import { create } from 'zustand';
export const useCookiesStore = create()((set, get) => ({
    setPreferences: preferences => set({ preferences }),
    configure: (config) => {
        configure(config);
        if (!get().isInitialized) {
            set({ isInitialized: true, preferences: getPreferences() });
            onPreferencesChanged(preferences => set({ preferences }));
        }
    },
}));
